import { inputAnatomy as parts } from "@chakra-ui/anatomy";
import { extendTheme, withDefaultColorScheme } from "@chakra-ui/react";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";

import { BUTTON_STYLES } from "./button-styles";
import { TABLE_STYLES } from "./table";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const variants = {
  outline: definePartsStyle({
    field: {
      borderColor: "brand.primary",
    },
  }),
};

const inputTheme = defineMultiStyleConfig({
  variants,
  defaultProps: {
    variant: "outline",
  },
});

const HEADING_STYLES = {
  baseStyle: {
    fontWeight: "500",
    color: "brand.text",
  },
  sizes: {
    h1: {
      fontSize: "42px",
      lineHeight: "48px",
    },
    h2: {
      fontSize: "36px",
      lineHeight: "42px",
    },
    h3: {
      fontSize: "30px",
      lineHeight: "36px",
    },
    h4: {
      fontSize: "24px",
      lineHeight: "30px",
    },
    h5: {
      fontSize: "21px",
      lineHeight: "27px",
    },
    h6: {
      fontSize: "16px",
      lineHeight: "22px",
    },
  },
};

export const THEME = extendTheme(withDefaultColorScheme({ colorScheme: "blue" }), {
  styles: {
    global: () => ({
      "*": {
        rounded: "0 !important",
      },
      body: {
        color: "#404040",
      },
    }),
  },

  colors: {
    brand: {
      primary: "#699746",
      primary_hover: "#4B712D",
      secondary: "#DCE7D9",
      secondary_hover: "#AAC6A2",
      text: "#143E53",
      bg: "#F5F5F5",
      page_bg: "linear-gradient(to bottom, #E6F5FE, #FFFFFF, #E6F5FE)",
    },
  },

  sizes: {
    button: "48px",
  },

  fonts: {
    body: "'TBISans', sans-serif",
  },

  components: {
    Heading: HEADING_STYLES,
    Button: BUTTON_STYLES,
    Table: TABLE_STYLES,
    Input: inputTheme,
    Spinner: {
      baseStyle: {
        rounded: "100% !important",
        borderColor: "brand.secondary",
      },
    },
  },
});
